module.exports = __webpack_public_path__ + "static/indywidualne-919ea4bd8d714641454db6442744bed8.jpg";